import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortTier'
})
export class SortTierPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
